import React from 'react';
import * as identifierUrl from '../../utils/identifier-url';
import formatIdentifierName from '../../utils/format-identifier-name';
import BasicLink from '../BasicLink';

if (process.browser) require('./Identifiers.scss');

const track = { context: 'Document' };

const Identifier = ({ type, value }) => {
  const urlFormatter = identifierUrl[type.toLowerCase()];
  const url = urlFormatter && urlFormatter(value);
  const trackDetails = {
    ...track, action: 'FindThisDocument', value: { documentIdentifier: type }, label: value
  };

  return (
    <li className="identifiers-list-item" data-name={`identifier-${type}`}>
      <span className="identifiers-list-label">{ `${formatIdentifierName(type)}: ` }</span>
      {
        url
          ? <BasicLink className="identifiers-list-value" track={trackDetails} external to={url}>{value}</BasicLink>
          : <span className="identifiers-list-value">{value}</span>
      }
    </li>
  );
};

export default function Identifiers({ identifiers = {} }) {
  const identifierTypes = Object.keys(identifiers);
  const identifierItems = identifierTypes
    .reduce((components, type) => {
      const value = identifiers[type];
      return (type && value)
        ? components.concat(<Identifier key={components.length} type={type} value={value} />)
        : components;
    }, []);

  if (!identifierItems.length) return <p data-name="no-identifiers">There are no full text links</p>;

  return (
    <ul className="bare-list" data-name="identifiers-list">
      { identifierItems }
    </ul>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/Identifiers/Identifiers.js